import styled from '@emotion/styled';

export const PaymentTable = styled('table')`
  border-collapse: collapse;
  width: 100%;
  border-spacing: 2px;
  border-color: grey;
`;

export const PaymentTableBody = styled('tbody')``;

export const PaymentTableRow = styled('tr')`
  border-bottom: 1px solid #dadada;

  &:last-child {
    border-bottom: 0;
  }
`;

export const PaymentTableHeader = styled('th')`
  text-align: left;
  padding: 8px;

  &:first-of-type {
    padding-left: 0;
  }
`;

export const PaymentTableData = styled('td')`
  text-align: right;
  padding: 8px;

  &:last-child {
    padding-right: 0;
  }
`;
